/**
 * Status real do servidor para a pílula do topo e o cartão "Serviços".
 *
 * É o mesmo ping do warm-up que a tela de login sempre fez (JWKS público):
 * além de acordar o backend enquanto a pessoa digita, a resposta diz se o
 * login vai funcionar. Ver `warmupAccessApi` no AuthContext.
 *
 * Estados: "verificando" (primeira resposta ainda não chegou), "ok" e
 * "falha". Re-checa a cada minuto e quando o navegador volta a ficar online.
 */
import { useEffect, useState } from "react";

import { warmupAccessApi } from "../../../context/AuthContext";

export const INTERVALO_STATUS_MS = 60 * 1000;

export const STATUS_VERIFICANDO = "verificando";
export const STATUS_OK = "ok";
export const STATUS_FALHA = "falha";

export default function useStatusDoServidor() {
  const [status, setStatus] = useState(STATUS_VERIFICANDO);

  useEffect(() => {
    let ativo = true;
    const verificar = () => {
      warmupAccessApi().then((ok) => {
        if (ativo) setStatus(ok ? STATUS_OK : STATUS_FALHA);
      });
    };
    verificar();
    const intervalo = window.setInterval(verificar, INTERVALO_STATUS_MS);
    window.addEventListener("online", verificar);
    return () => {
      ativo = false;
      window.clearInterval(intervalo);
      window.removeEventListener("online", verificar);
    };
  }, []);

  return status;
}
